import AppLayout from "../layouts/AppLayout";

interface ArticleProps {
    article: {
        title: string;
        content: string;
    };
}

export default function Article({ article }: ArticleProps) {
    return (
        <AppLayout>
            <div className="w-full">
                <article className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-20 pt-0 flex flex-col">
                    <h1 className="text-3xl font-bold mb-4 text-gray-900">{article.title}</h1>
                    <div className="prose prose-lg max-w-none">
                        {article.content}
                    </div>
                </article>
            </div >
        </AppLayout >
    )
}